import { Link } from "react-router-dom";
import styled from "styled-components";

export const Nav = styled.nav`
  display: flex;
  justify-content: center;
  box-shadow: ${({ theme }) => theme.shadow};
  padding: 0 10px;

  border-radius: 10px;
  background-color: ${({ theme }) => theme.box};
`;

export const Menu = styled.ul`
  position: relative;
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: ${({ drop }) => (drop ? "column" : "row")};
  width: 100%;
  height: fit-content;
  padding: 10px;
`;

export const MenuItem = styled.li`
  position: relative;
  /* margin-right: ${({ drop }) => (drop ? "0" : "2rem")}; */
  margin-bottom: ${({ drop }) => (drop ? "1rem" : "0")};
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: ${({ drop }) => (drop ? "0" : "0rem")};
  display: flex;
  width: ${({ drop }) => (drop ? "100%" : "")};
  background-color: ${({ isShowDropdown }) => (isShowDropdown ? "red" : null)};
  &:first-child {
    margin-right: 0;
  }
`;

export const NavLink = styled(Link)`
  display: flex;
  color: ${({ theme }) => theme.text};
  font-size: ${({ drop }) => (drop ? "12px" : "12px")};
  text-align: right;
  /* flex-direction: column; */
  align-items: center;
  justify-content: center;
  padding: 5px 0px;
  /* height: 75%; */
  width: 100%;

  background-color: ${({ bgColor }) => bgColor};
  @media (max-width: 768px) {
    p {
      font-size: 12px;
    }
  }
  /* @media (max-width: 768px) {
    padding: 0px;

  @media (max-width: 1240px) {
    p {
      font-size: 14px !important;
    }
    svg {
      font-size: 14px;
    }
  } */
  /* @media (max-width: 960px) {
    p {
      font-size: 12px !important;
      padding: 0;
    }
    svg {
      font-size: 14px;
    }

  } */
  /* border-radius-: 10px; */
  /* background-color: "#E2EDFB"; */
`;

export const DropDown = styled.div`
  width: 180px;
  /* height: 200px; */
  position: absolute;
  top: 56px;
  display: none;
  border-radius: 10px;
  box-shadow: ${({ theme }) => theme.shadow};
  background-color: ${({ theme }) => theme.box};
  display: ${({ isShowDropdown }) => (isShowDropdown ? "block" : "none")};
  padding: 1rem;
  -webkit-animation: scale-up-top 0.4s cubic-bezier(0.39, 0.575, 0.565, 1) both;
  animation: scale-up-top 0.4s cubic-bezier(0.39, 0.575, 0.565, 1) both;
  z-index: 100;

  @-webkit-keyframes scale-up-top {
    0% {
      -webkit-transform: scale(0.5);
      transform: scale(0.5);
      -webkit-transform-origin: 50% 0%;
      transform-origin: 50% 0%;
    }
    100% {
      -webkit-transform: scale(1);
      transform: scale(1);
      -webkit-transform-origin: 50% 0%;
      transform-origin: 50% 0%;
    }
  }
  @keyframes scale-up-top {
    0% {
      -webkit-transform: scale(0.5);
      transform: scale(0.5);
      -webkit-transform-origin: 50% 0%;
      transform-origin: 50% 0%;
    }
    100% {
      -webkit-transform: scale(1);
      transform: scale(1);
      -webkit-transform-origin: 50% 0%;
      transform-origin: 50% 0%;
    }
  }
`;
